// extracted by mini-css-extract-plugin
export default {"error-page":"styles_error-page__Vx9mD"};